const HOURS_IN_ONE_DAY = 24;
const MINUTES_IN_ONE_HOUR = 60;

const getHoursToNextDay = () => {
  const currentHours = new Date().getHours();
  const currentMinutes = new Date().getMinutes();
  // hoursDiff is difference in full hours
  const hoursDiff = HOURS_IN_ONE_DAY - currentHours - 1;
  const minutesDiff = MINUTES_IN_ONE_HOUR - currentMinutes;

  return hoursDiff + minutesDiff / MINUTES_IN_ONE_HOUR;
};

export {getHoursToNextDay};
